import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Niciun grup de modificatori încă. Creați unul nou.',
  fields: {
    name: 'Nume',
    external_id: 'Ref {{integration}}',
    prices: 'Prețuri',
    available: 'Disponibil',
    status: 'Status',
    statuses: {
      good: 'Bun',
      bad: 'Rău',
      medium: 'Mediu',
    },
  },
  order_method_prices: {
    base: 'De bază',
    [ORDER_METHODS.pickup]: 'Ridicare',
    [ORDER_METHODS.delivery]: 'Livrare',
    [ORDER_METHODS.room_service]: 'Serviciu la masă/cameră',
  },
  labels: {
    visible: 'Vizibil în meniu',
    hidden: 'Toate ascunse',
  },
  buttons: {
    add_modifier: 'Adaugă modificator',
    delete_modifier_one: 'Șterge modificatorul',
    delete_modifier_few: 'Șterge modificatori',
    delete_modifier_other: 'Șterge modificatorii',
    show_modifier_group: 'Afișează grupul de modificatori',
    close_modifier_group: 'Închide grupul de modificatori',
    edit: 'Editează',
    duplicate: 'Duplică',
    history: 'Istoric',
  },
  toasts: {
    failed_to_duplicate_modifier_group: 'Eroare la duplicarea grupului de modificatori',
    modifier_group_duplicated_successfully: 'Grupul de modificatori a fost duplicat cu succes',
    failed_to_duplicate_modifier: 'Eroare la duplicarea modificatorului',
    modifier_duplicated_successfully: 'Modificatorul a fost duplicat cu succes',
  },
};
